<template>
    <v-btn-toggle v-model="query.type" borderless active-class="white elevation-4" color="primary" class="grey lighten-4" style="width:100%;border-radius:8px!important" @change="emit">
        <template v-for="{ text, value } in types">
            <v-btn :width="`calc(100% / ${types.length})`" style="border-radius: 8px!important;" v-bind="{ value }" :key="text"> {{ text }} </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
const initQuery = (form = {}) => ({
    ...(form || {}),
    type: form?.type || null,
});

const types = [
    { text: "전체", value: null },
    { text: "충전", value: "inc" },
    { text: "사용 (선물)", value: "dec" },
    { text: "리워드 캐시충전", value: "rwd" },
];
export default {
    data: () => ({
        query: initQuery(),

        types,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query.type) delete query.type;

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    opacity: 1;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active.white {
    border-width: 1px;
    border-style: solid;
    border-color: var(--v-primary-base) !important;
}
</style>
